import 'array-flat-polyfill';

if (!Object.entries) {
  Object.entries = function (obj) {
    var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}

if (!Array.prototype.find) {
  /*eslint-disable-next-line no-extend-native*/
  Array.prototype.find = function (callback) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    } else if (typeof callback !== 'function') {
      throw new TypeError('callback must be a function');
    }

    var list = Object(this);
    // Makes sures is always has an positive integer as length.
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    for (var i = 0; i < length; i++) {
      var element = list[i];
      if (callback.call(thisArg, element, i, list)) {
        return element;
      }
    }
  };
}

if (!Promise.prototype.finally) {
  /*eslint no-extend-native: ["error", { "exceptions": ["Promise"] }]*/
  Promise.prototype.finally = {
    finally(fn) {
      const onFinally = (cb) => Promise.resolve(fn()).then(cb);
      return this.then(
        (result) => onFinally(() => result),
        (reason) => onFinally(() => Promise.reject(reason))
      );
    },
  }.finally;
}
